import PropTypes from "prop-types"
import { Paper } from "@mui/material"
import { formatLongDate } from "helpers/formatters/dates"
import Factor from "./factor"
import "./style.scss"

function SecurityProfileAttribution({ date, attribution, maxFactors, openFactorProfile }) {
  return <Paper className="components_top-attribution">
    <h2 className="header">{attribution.category} as of <span className="attribution-date">{formatLongDate(date)}</span></h2>
    <div className="charts-wrapper">
      <div className="chart">
        {attribution.factors.map((factor, i) => <Factor key={i} factor={factor} max={maxFactors} otherLabel="All Other Winning Factors" openFactorProfile={openFactorProfile} />)}
      </div>
    </div>
  </Paper>
}

SecurityProfileAttribution.propTypes = {
  date: PropTypes.string.isRequired,
  attribution: PropTypes.object.isRequired,
  openFactorProfile: PropTypes.func.isRequired,
  maxFactors: PropTypes.number.isRequired,
}

export default SecurityProfileAttribution
